import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/countries/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/countries/?page[size]=1000&sort=nombre`);
};

const get = async (id) => {
  return await httpClient.get(`/countries/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/countries/${id}/`, data);
};

const patch = async (id) => {
  return await httpClient.patch(`/countries/${id}`);
};

const remove = async (id) => {
  return await httpClient.delete(`/countries/${id}`);
};

export { post, getAll, get, put, patch, remove };
